export default {"src":"/uk/_next/static/media/pinIcon.5881abb5.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};